import { Alert, Button, Checkbox, Container, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from "react";
import { Backend } from "../../services/Backend";
import { SuccessToast } from "../../utils/utils";
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    description: Yup.string().required('Description is required'),
    url: Yup.string().required('URL is required'),
    publicationYear: Yup.string().matches(/^\d{4}$/, 'Publication year must be a 4-digit number').required('Publication year is required'),
    publicationMonth: Yup.string().matches(/^\d{1,2}$/, 'Publication month must be a number between 1 and 12').required('Publication month is required'),
    disciplinaryContext: Yup.string().required('Disciplinary context is required'),
    language: Yup.string().required('Language is required'),
    interest: Yup.string().required('Interest is required'),
    title: Yup.string().required('Title is required'),
});

export default function SubmitUrlPage() {
    const [title, setTitle] = useState("");
    const [interest, setInterest] = useState("");
    const [language, setLanguage] = useState("");
    const [publicationMonth, setPublicationMonth] = useState("");
    const [publicationYear, setPublicationYear] = useState("");
    const [description, setDescription] = useState("");
    const [url, setUrl] = useState("");
    const [uploadByCompany, setUploadByCompany] = useState(false);
    const [disciplinaryContext, setDisciplinaryContext] = useState("");
    const [agree, setAgree] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async () => {
        try {
            await validationSchema.validate({
                title,
                interest,
                language,
                publicationMonth,
                publicationYear,
                description,
                url,
                disciplinaryContext,
            });

            const body = {
                title,
                interest,
                language,
                uploadByCompany,
                publicationMonth,
                publicationYear,
                description,
                url,
                disciplinaryContext,
            };

            Backend.post('url', body)
                .then(res => {
                    SuccessToast("Url submitted successfully");
                    setTimeout(() => window.location.href = '/search-best-practice', 1000);
                });
        } catch (err) {
            setError(err.message);
        }
    }

    return <Container maxWidth="lg" className="my-5">
        <h1 className="text-2xl">Submit URL</h1>

        <div className="w-[50%]">
            { error && <Alert severity="error">{error}</Alert> }
            <TextField margin="normal" required fullWidth label="Title" value={title} onChange={(e) => setTitle(e.target.value)}  />
            
            <FormControl fullWidth  margin="normal">
                <InputLabel>Interest</InputLabel>
                <Select
                    label="Interest"
                    margin="normal"
                    value={interest}
                    onChange={(e) => setInterest(e.target.value)}
                    required
                >
                    <MenuItem value="Transport safety">Transport safety</MenuItem>
                    <MenuItem value="Industrial safety">Industrial safety</MenuItem>
                    <MenuItem value="Chemical warehousing">Chemical warehousing</MenuItem>
                    <MenuItem value="Tank storage">Tank storage</MenuItem>
                </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <InputLabel>Language</InputLabel>
                <Select
                    label="Language"
                    margin="normal"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    required
                >
                    <MenuItem value="English">English</MenuItem>
                    <MenuItem value="Dutch">Dutch</MenuItem>
                    <MenuItem value="German">German</MenuItem>
                    <MenuItem value="Spanish">Spanish</MenuItem>
                    <MenuItem value="French">French</MenuItem>
                    <MenuItem value="Chinese">Chinese</MenuItem>
                </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <InputLabel>Disciplinary context</InputLabel>
                <Select
                    label="Disciplinary context"
                    margin="normal"
                    value={disciplinaryContext}
                    onChange={(e) => setDisciplinaryContext(e.target.value)}
                    required
                >
                    <MenuItem value="Normative">Normative</MenuItem>
                    <MenuItem value="Scientific">Scientific</MenuItem>
                    <MenuItem value="Tools and techniques">Tools and techniques</MenuItem>
                    <MenuItem value="Legislative">Legislative</MenuItem>
                </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <InputLabel>Upload by company</InputLabel>
                <Select
                    label="Upload by company"
                    margin="normal"
                    value={uploadByCompany}
                    onChange={(e) => setUploadByCompany(e.target.value === 'true')}
                    required
                >
                    <MenuItem value="false">No</MenuItem>
                    <MenuItem value="true">Yes</MenuItem>
                   
                </Select>
            </FormControl>
            <TextField margin="normal" required fullWidth label="Publication month" type="number" value={publicationMonth} onChange={(e) => setPublicationMonth(e.target.value)} />
            <TextField margin="normal" required fullWidth label="Publication year" type="number" value={publicationYear} onChange={(e) => setPublicationYear(e.target.value)} />
            <TextField margin="normal" required fullWidth label="URL" value={url} onChange={(e) => setUrl(e.target.value)} />
            <TextField label="Description" sx={{mt: 2}} multiline rows={5} fullWidth value={description} onChange={(e) => setDescription(e.target.value)} />
            <FormControlLabel control={<Checkbox value={agree} onChange={(e) => setAgree(e.target.checked)} />} label={<p className="text-sm">I agree with the <a href="/conditions" target="_blank" className="text-blue-500 hover:underline hover:text-blue-600">terms and conditions</a></p>} />

            <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onSubmit} 
                disabled={!agree}
            > Publish
            </Button>
        </div>
    </Container>
}